<script>
  import Navbar from "../Navbar.svelte";
  import { onMount } from "svelte";
</script>

<style>
  .timesheet-pto-request {
    color: #013c61;
    font-size: 4em;
    font-weight: bolder;
    margin: 0 auto;
    margin-top: 15rem;
    text-align: center;
  }
</style>

<Navbar />
<div class="timesheet-pto-request">PTO Request has been approved</div>
